export default {
  'no-notifications': {
    'text': 'Ваш браузер не поддерживает технологию push-уведомлений',
    'status': 'warning'
  },
  'already-denied': {
    'text': 'Вы нам запретили отправлять пуш-уведомления',
    'status': 'warning'
  },
  'deny-now': {
    'text': false,
    'status': 'warning'
  },
  'fail-subscribe': {
    'text': 'Не удалось подписаться :(',
    'status': 'error'
  },
  'fail-unsubscribe': {
    'text': 'Не удалось отписаться :(',
    'status': 'error'
  },
  'unsubscribed': {
    'text': 'Вы успешно отписаны от пуш-уведомлений',
    'status': 'success'
  },
  'subscribed': {
    'text': 'Спасибо за подписку!',
    'status': 'success'
  }
}